import { Bitcoin, CreditCard, DollarSign, Wallet } from "lucide-react";
import type { PaymentMethod, PaymentProvider } from "@/types/payment";

export const getMethodIcon = (method: PaymentProvider) => {
  switch (method) {
    case "credit-card":
      return <CreditCard className="h-6 w-6" />;
    case "zelle":
    case "cashapp":
      return <DollarSign className="h-6 w-6" />;
    case "crypto":
      return <Bitcoin className="h-6 w-6" />;
    default:
      return <Wallet className="h-6 w-6" />;
  }
};

export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: "credit-card",
    label: "Credit Card",
    icon: <CreditCard className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "2.9% + $0.30"
  },
  {
    id: "mtn",
    label: "MTN Mobile Money",
    icon: <Wallet className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "1.5%"
  },
  {
    id: "airtel",
    label: "Airtel Money",
    icon: <Wallet className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "1.5%"
  },
  {
    id: "vodafone",
    label: "Vodafone Cash",
    icon: <Wallet className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "1.5%"
  },
  {
    id: "zelle",
    label: "Zelle",
    icon: <DollarSign className="h-6 w-6" />,
    processingTime: "1-24 hours",
    fee: "No fee"
  },
  {
    id: "cashapp",
    label: "Cash App",
    icon: <DollarSign className="h-6 w-6" />,
    processingTime: "1-24 hours",
    fee: "No fee"
  },
  {
    id: "crypto",
    label: "Cryptocurrency",
    icon: <Bitcoin className="h-6 w-6" />,
    processingTime: "10-60 minutes",
    fee: "Network fee applies"
  },
  {
    id: "payhab",
    label: "PayHab",
    icon: <Wallet className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "1.5%"
  },
  {
    id: "paystack",
    label: "Paystack",
    icon: <Wallet className="h-6 w-6" />,
    processingTime: "Instant",
    fee: "1.8%"
  }
];